import { get, post } from '../utils/api'
import { isValidNull, isValidEmail, isValidPhoneNumber, isValidNumber } from '../utils/valid';

export const fetchInquiryListData = async (searchVal, pageIdx) => {
  try {
    const response = await get('/inquiry/list', {
      searchParam: searchVal,
      pageIdx: pageIdx
    });
    return response;
  } catch (error) {
    return [];
  };
};

export const validateInquiryFormData = async (formData, agreement, securityCode) => {
  
  if (!isValidNull(formData.title, 'iqTitle')) return { valid: false, message: '제목을 입력해주세요' };
  if (!isValidNull(formData.cpnName, 'iqCpnName')) return { valid: false, message: '업체명을 입력해주세요' };
  if (!isValidNull(formData.staffName, 'iqStaffName')) return { valid: false, message: '담당자명을 입력해주세요' };
  if (!isValidNull(formData.phone, 'iqPhone')) {
    return { valid: false, message: '연락처를 입력해주세요' };
  } else if (!isValidPhoneNumber(formData.phone, 'iqPhone')) {
    return { valid: false, message: '올바른 전화번호 형식이 아닙니다.' };
  }
  if (!isValidNull(formData.email, 'iqEmail')) {
    return { valid: false, message: '이메일을 입력해주세요' };
  } else if (isValidNull(formData.email, 'iqEmail') &&!isValidEmail(formData.email, 'iqEmail')) {
    return { valid: false, message: '올바른 이메일 형식이 아닙니다.' };
  }
  if (!isValidNumber(formData.quantity)) {
    return { valid: false, message: '올바른 수량을 입력해주세요' };
  }
  if (!isValidNull(formData.content, 'iqContent')) return { valid: false, message: '내용을 입력해주세요' };
  if (!isValidNull(formData.security, 'iqSecurity')){
    return { valid: false, message: '보안문자를 입력해주세요' };
  } else if(formData.security !== securityCode) {
    return { valid: false, message: '보안문자가 틀립니다' };
  }
  if (!agreement) return { valid: false, message: '개인정보 이용 약관에 동의해주세요' };

  return { valid: true };
}

export const fetchInquiryInsertData = async (submitData, formData, agreement, securityCode) => {
  try {
    const validationResult = await validateInquiryFormData(formData, agreement, securityCode);
    
    if(!validationResult.valid) {
      alert(validationResult.message);
      return;
    } else {
      const response = await post('/inquiry/insert', submitData);
      return response;
    }

  } catch (error) {
    console.error('문의 등록 중 오류 발생:', error);
    alert('문의 등록 중 오류가 발생했습니다. 다시 시도해주세요.');
  }
}

export const fetchInquiryDetailData = async (idx) => {
  try {
    const response = await get('/inquiry/detail', { iqIdx : idx });
    return response;
  } catch (error) {
    return [];
  }
}